import VisibilityIcon from "@mui/icons-material/Visibility";
import { FormHelperText, Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import AttachFile from "../../components/Comman/AttachFile";
import { ButtonCompo } from "../../components/Comman/Button";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import { LabelCompo } from "../../components/Comman/Label";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../components/withRouter";
import { titleColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import {
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
  updateData,
} from "../../config/messageconstant";
import { imageUrl } from "../../config/Url";
import { mandatoryCheck, ValidationCheck } from "../../config/ValidationCheck";
import { MyLeaveJson } from "../../DynamicFormsJson/MastersJSON/myLeave";
import {
  getAreaByTalukaPostBodyUpdated,
  getAreaByUserType,
} from "../../Slice/area.slice";
import {
  getCategory,
  getCategoryByProductRateStructure,
} from "../../Slice/category.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getLeaveBalaceBySalesTeam } from "../../Slice/LeaveType.slice";
import { getProductByCategory } from "../../Slice/product.slice";
import { getRegion } from "../../Slice/region.slice";
import {
  getReportingAuthorityBySalesTeam,
  getReportingAuthorityBySalesTeamNew,
} from "../../Slice/salesExecutive.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import { getTalukaByDistrict } from "../../Slice/taluka.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import { apiGet, apiPost, apiPostForImage } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
class MyLeaveForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formErrors: {},
      leaveData: {},
      fileName: "",
      fieldData: { leaveFor: "0" },
      dynamicMasterData: {
        leaveTypeDetail: this.props.leaveList?.leaveBalanceBySalesTeam,
      },
      leaveTo: "",
      leaveToObj: {},
      imageSelect: false,
      invalidDate: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.leaveList !== nextProps.leaveList) {
      if (
        this.props.leaveList?.leaveBalanceBySalesTeam !==
        nextProps.leaveList?.leaveBalanceBySalesTeam
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            leaveTypeDetail: nextProps.leaveList?.leaveBalanceBySalesTeam,
          },
        });
      }
    }
  }

  async componentDidMount() {
    const {
      getReportingAuthorityBySalesTeam,
      getReportingAuthorityBySalesTeamNew,
      getLeaveBalaceBySalesTeam,
      showLoador,
      showNotification,
    } = this.props;

    const getLeaveAuthorityWiseData = localStorage.getItem(
      "getLeaveAuthorityWiseData"
    );

    if (navigator.onLine) {
      showLoador({ loador: true });
      await getLeaveBalaceBySalesTeam({ salesTeamId: "" }).then(
        ({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            let responseData = response.length !== 0 ? response[0] : {};
            this.setState({ leaveData: responseData });
          }
        }
      );

      if (getLeaveAuthorityWiseData == 1) {
        showLoador({ loador: true });
        await getReportingAuthorityBySalesTeamNew({
          salesTeamId: "",
          flag: 0,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            this.setState({
              fieldData: { leaveTo: response.name, leaveFor: "0" },
              leaveToObj: response,
            });
          }
        });
      } else {
        showLoador({ loador: true });
        await getReportingAuthorityBySalesTeam({ salesTeamId: "" }).then(
          ({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              this.setState({
                fieldData: { leaveTo: response.name, leaveFor: "0" },
                leaveToObj: response,
              });
            }
          }
        );
      }

      if (this.props.params.id) {
        this.getDataById(this.props.params.id);
      }
    } else {
      showNotification({
        msg: noInternetMsg,
        severity: "error",
      });
    }
  }

  checkValidationOnSubmit = () => {
    const { fieldData } = this.state;

    if (dayjs(fieldData.toDate).isBefore(dayjs(fieldData.fromDate))) {
      this.props.showNotification({
        msg: "To Date cannot be less than From Date",
        severity: "error",
      });
      return;
    }

    const mandatoryCheckErrors = mandatoryCheck({
      fieldData,
      fieldMeta: MyLeaveJson.fieldMeta,
    });
    this.setState({
      formErrors: mandatoryCheckErrors.formErrors,
    });

    if (mandatoryCheckErrors.formValid) {
      const ValidationCheckErrors = ValidationCheck({
        fieldData,
        fieldMeta: MyLeaveJson.fieldMeta,
      });
      this.setState({
        formErrors: ValidationCheckErrors.formErrors,
      });
      return ValidationCheckErrors.formValid;
    } else {
      return false;
    }
  };

  onDataChange = (fieldName, newValue) => {
    const { fieldData, formData, leaveData } = this.state;

    if (fieldName === "leaveType") {
      if (leaveData && leaveData.balanceLeave == 0) {
        this.props.showNotification({
          msg: "Leave balance is 0. You are not eligible to apply for leave.",
          severity: "error",
        });
      }
    }
    const dataToSearch = {};
    const dataToReset = { ...this.state.fieldData };
    MyLeaveJson.fieldMeta.map((currentField) => {
      if (currentField.dataKey === fieldName && currentField.getListId) {
        const masterKeyList = currentField.getListId.split(",");

        masterKeyList.map((key) => {
          if (fieldName === key) {
            dataToSearch[key] = newValue;
          } else if (fieldData[key]) {
            dataToSearch[key] = fieldData[key];
          }
          return null;
        });
      }
      if (currentField.getListFrom) {
        const masterKeyList = currentField.getListFrom.split(",");
        masterKeyList.map((key) => {
          if (key == fieldName && dataToReset[key]) {
            delete dataToReset[currentField.dataKey];
          }
        });
      }
      return null;
    });

    dataToReset[fieldName] = newValue;
    this.setState({
      fieldData: dataToReset,
    });
  };

  getDataById = (id) => {
    const { showLoador, showNotification } = this.props;
    const { fieldData } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      const response = apiGet({
        url: MyLeaveJson.apiBaseURL + "/" + id,
      }).then(({ data, success }) => {
        console.log(data.data);
        showLoador({ loador: false });
        if (success) {
          if (!data.error) {
            let rowData = {
              leaveType:
                data.data.leaveType !== null && data.data.leaveType.id !== null
                  ? data.data.leaveType.id
                  : "",
              subject:
                data.data.leaveReason !== null ? data.data.leaveReason : "",
              leaveTo: fieldData.leaveTo,
              noOfDays: data.data.noOfDays !== null ? data.data.noOfDays : "",
              leaveFor:
                data.data.noOfDays !== null
                  ? data.data.noOfDays >= 1
                    ? "0"
                    : "1"
                  : "",
              fromDate: data.data.fromDate !== null ? data.data.fromDate : "",
              toDate: data.data.toDate !== null ? data.data.toDate : "",
              description:
                data.data.description !== null ? data.data.description : "",
              fileName:
                data.data.attachFile !== null ? data.data.attachFile : "",
            };

            this.setState({ fieldData: rowData });

            return { data: rowData, success };
          }
          return { data: {}, success: false };
        } else {
          showNotification({ msg: serverMsg, severity: "error" });
        }

        return { data: {}, success: false };
      });
      return response;
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  changeH = (fileName, name, index) => {
    this.setState({
      ...this.state,
      fileName: fileName,
    });
  };

  onClickViewPreview = (e, row) => {
    e.stopPropagation();
    const url = URL.createObjectURL(row);
    window.open(url);
  };

  onSave = (dataToSave) => {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      apiPost({
        url: endpoint.leaveApply,
        postBody: dataToSave,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          showNotification({ msg: savemsg });
          this.props.navigate(-1);
        } else {
          showNotification({ msg: saveFailedMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSubmitData = async () => {
    const { showLoador, showNotification } = this.props;
    const { fieldData, fileName, leaveData, leaveToObj } = this.state;

    if (this.checkValidationOnSubmit()) {
      const fromDateWithFormat = dayjs(fieldData.fromDate).format("DD-MM-YYYY");
      const toDateWithFormat = dayjs(fieldData.toDate).format("DD-MM-YYYY");

      const from = dayjs(fieldData.fromDate);
      const to = dayjs(fieldData.toDate);

      const daysDifference = to.diff(from, "day") + 1;

      // Comment By Ritesh
      // if (leaveData.balanceLeave < (fieldData.leaveFor == 0 ? daysDifference : (daysDifference) * 0.5)) {
      //   showNotification({ msg: "Leave duration exceeds the available leave balance, so you cannot apply for leave", severity: "error" });
      //   return
      // }

      let dataToSave = {};

      let fileNameData = "";

      swal({
        title: "Are you sure?",
        text: this.props.params.id ? updateData : saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          if (fileName && fileName !== "") {
            fileNameData =
              dayjs(fileName.lastModifiedDate).format("hh:mm:ss") +
              fileName.name;

            const formData = new FormData();
            formData.append("file", fileName);
            formData.append("imageName", fileNameData);

            showLoador({ loador: true });
            await apiPostForImage({
              url: endpoint.uploadImage,
              postBody: formData,
            }).then(({ data, success }) => {
              showLoador({ loador: false });
              if (success) {
              } else {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            });
          }

          let authorityUserStockStakeHolderTypeId =
            leaveToObj && leaveToObj.stockStakeHolderTypeId;

          let authorityUserId = leaveToObj && leaveToObj.id;

          let userId =
            localStorage.getItem("userId") && localStorage.getItem("userId");

          let fromDateForSave = this.props.params.id
            ? fieldData.fromDate
            : fromDateWithFormat;
          let toDateForSave = this.props.params.id
            ? fieldData.toDate
            : toDateWithFormat;

          if (this.props.params.id) {
            dataToSave = {
              id: this.props.params.id ? this.props.params.id : null,
              salesTeam: {
                id: userId,
              },
              leaveType: {
                id: fieldData.leaveType,
              },
              authoritySalesPersonId: authorityUserId,
              authoritySalesPersonTypeId: authorityUserStockStakeHolderTypeId,
              fromDate: fromDateForSave,
              toDate: toDateForSave,
              leaveReason: fieldData.subject,
              description: fieldData.description,
              noOfDays: this.props.params.id
                ? fieldData.noOfDays
                : fieldData.leaveFor == 0
                ? daysDifference
                : daysDifference * 0.5,
              status: 0,
              isActive: 1,
              leaveCancelRemark: "",
              attachFile: fileNameData
                ? fileNameData
                : fieldData.fileName
                ? fieldData.fileName
                : "",
            };
          } else {
            dataToSave = {
              salesTeam: {
                id: userId,
              },
              leaveType: {
                id: fieldData.leaveType,
              },
              authoritySalesPersonId: authorityUserId,
              authoritySalesPersonTypeId: authorityUserStockStakeHolderTypeId,
              fromDate: fromDateForSave,
              toDate: toDateForSave,
              leaveReason: fieldData.subject,
              description: fieldData.description,
              noOfDays:
                fieldData.leaveFor == 0 ? daysDifference : daysDifference * 0.5,
              status: 0,
              isActive: 1,
              leaveCancelRemark: "",
              attachFile: fileNameData ? fileNameData : "",
            };
          }

          if (this.props.params.id) {
            this.onSave(dataToSave);
          } else {
            showLoador({ loador: true });
            apiGet({
              url:
                endpoint.leaveApply +
                "/check-applicable-or-not?salesTeamId=" +
                userId +
                "&fromDate=" +
                fromDateForSave +
                "&toDate=" +
                toDateForSave,
            }).then(({ data, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                if (data && data.data && data.data.statusCode == 500) {
                  showNotification({
                    msg: "Leave Already Applied",
                    severity: "error",
                  });
                } else {
                  this.onSave(dataToSave);
                }
              }
            });
          }
        }
      });
    }
  };

  render() {
    const {
      dynamicMasterData,
      formErrors,
      fieldData,
      open,
      fileName,
      imageSelect,
    } = this.state;

    return (
      <>
        {!open && (
          <>
            <Paper
              sx={{
                padding: 2,
              }}
              elevation={0}
            >
              <DynamicFormWithoutValidation
                dynamicMasterData={dynamicMasterData}
                screenTitle={MyLeaveJson.screenTitle}
                fieldMeta={
                  this.props.params.id
                    ? MyLeaveJson.fieldMetaForEdit
                    : MyLeaveJson.fieldMeta
                }
                apiBaseURL={MyLeaveJson.apiBaseURL}
                formErrors={formErrors}
                showSaveBtn={MyLeaveJson.showSaveBtn}
                showSaveBtnMain={false}
                getDataById={this.getDataById}
                getByIdApi={true}
                callApi={true}
                fieldData={fieldData}
                onDataChange={this.onDataChange}
                showBackToList={true}
              />
              <Grid
                item
                sm={6}
                xs={12}
                md={6}
                lg={6}
                container
                justifyContent="space-between"
              >
                <Grid item xs={12} md={5} sm={5}>
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, color: titleColor }}
                    label="Select Image:"
                  />
                </Grid>
                <Grid item xs={12} md={7} sm={7}>
                  <AttachFile name={"file"} fileName={this.changeH} />
                  &nbsp; {fileName !== "" ? fileName.name : ""}
                  &nbsp;{" "}
                  {fileName !== "" ? (
                    <MyComponentWithIconProps
                      statusImage={VisibilityIcon}
                      color="primary"
                      fontSize="medium"
                      title="View"
                      onClick={
                        this.props.params.id && imageSelect
                          ? (e) => this.onClickViewPreview(e, fileName)
                          : this.props.params.id
                          ? () => {
                              window.open(imageUrl + fileName.name, "_blank");
                            }
                          : (e) => this.onClickViewPreview(e, fileName)
                      }
                    />
                  ) : (
                    <FormHelperText error>
                      {formErrors["imageError"] ? formErrors["imageError"] : ""}
                    </FormHelperText>
                  )}
                </Grid>
              </Grid>
              <br />

              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="right"
              >
                <ButtonCompo
                  size="medium"
                  type="button"
                  variant="contained"
                  name="Apply For Leave"
                  onClick={this.onSubmitData}
                />
              </Grid>
            </Paper>
          </>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesTeamList: state.salesExecutive,
  areaList: state.area,
  categoryList: state.category,
  productList: state.product,
  regionList: state.region,
  zoneList: state.zone,
  stateList: state.states,
  districtList: state.district,
  talukaList: state.taluka,
  leaveList: state.leaveType,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getProductByCategory,
  getCategory,
  getRegion,
  getStateByRegion,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getAreaByTalukaPostBodyUpdated,
  getAreaByUserType,
  getCategoryByProductRateStructure,
  getLeaveBalaceBySalesTeam,
  getReportingAuthorityBySalesTeam,
  getReportingAuthorityBySalesTeamNew,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(MyLeaveForm);
